import { FC, ReactNode } from "react";
import LeftRailNavigationFlatDesktop from "./LeftRailNavigationFlatDesktop";
import LeftRailNavigationFlatMobile from "./LeftRailNavigationFlatMobile";
import useActiveItemIndex from "../useActiveItemIndex";
import { SECONDARY_NAV_ID, STICKY_NAV_ID } from "@/components/StickyNavigation";

export type LeftRailNavigationFlatProps = {
  navItemsHeadline?: string;
  navItems: {
    name: string;
    href: string;
    dlt: string;
    dld: string;
  }[];
  children?: ReactNode[];
  onMobileNavChange?: (value: string) => void;
};

const LeftRailNavigationFlat: FC<LeftRailNavigationFlatProps> = ({
  navItems,
  navItemsHeadline,
  children,
  onMobileNavChange,
}) => {
  const getSecondaryNavOffset = () => {
    if (typeof document === "undefined") {
      return 0;
    }
    const secondaryNavOffset =
      document.getElementById(SECONDARY_NAV_ID)?.offsetHeight || 0;
    const stickyNavOffset =
      document.getElementById(STICKY_NAV_ID)?.offsetHeight || 0;
    return secondaryNavOffset + stickyNavOffset;
  };

  const offset = getSecondaryNavOffset();

  const { activeItemIndex, initialActiveItemIndex } = useActiveItemIndex(
    navItems.map((item) => ({ id: item.href.replace("#", "") })),
    {
      initialFromHash: true,
      listenToHashChange: true,
      offset,
    },
  );

  const LeftRailNavigationStructure = (
    <>
      <div className="block lg:hidden">
        {initialActiveItemIndex !== undefined && (
          <LeftRailNavigationFlatMobile
            navItems={navItems}
            initialActiveItemIndex={initialActiveItemIndex}
            onMobileNavChange={onMobileNavChange}
          />
        )}
      </div>
      <div
        className="sticky hidden h-max w-full max-w-86.75 lg:block lg:shrink-0"
        style={{ top: offset > 0 ? offset + 32 : 32 }}
      >
        {navItemsHeadline && (
          <p className="text-subhead-s leading-xs text-headline mb-8 font-bold">
            {navItemsHeadline}
          </p>
        )}
        <LeftRailNavigationFlatDesktop
          navItems={navItems}
          activeItemIndex={activeItemIndex}
        />
      </div>
    </>
  );

  return children !== undefined ? (
    <div className="flex flex-col gap-x-8 gap-y-10 lg:flex-row">
      {LeftRailNavigationStructure}
      <div className="flex flex-col">{children}</div>
    </div>
  ) : (
    <>{LeftRailNavigationStructure}</>
  );
};

export default LeftRailNavigationFlat;
